<button
  pButton
  size="small"
  severity="primary"
  [rounded]="true"
  [icon]="
    dataLayerStore.isInSelection(dataLayer)
      ? 'fas fa-check-circle'
      : 'fa-regular fa-circle'
  "
  [label]="dataLayer.year + ''"
  (click)="selectDataLayer(dataLayer)"
  [ngClass]="{
    'p-button-outlined': !dataLayerStore.isInSelection(dataLayer)
  }"></button>
